import React from "react";

import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import "./lib/i18n";
import App from "./App";
import { AdminStoreProvider } from "./stores/adminStore";
import { StoreProvider } from "./stores/index";
import "./index.css";

const isDev = import.meta.env.DEV;

// Initialize Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div>
          An error has occurred....
          {isDev ? <pre>{(error as Error).stack}</pre> : null}
        </div>
      )}
    >
      <StoreProvider>
        <AdminStoreProvider>
          <App />
        </AdminStoreProvider>
      </StoreProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
